<template>
  <el-config-provider :locale="locale">
    <router-view />
    <FloatingBall ref="floatingBallRef"/>
  </el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import FloatingBall from './modules/my-interview/components/FloatingBall.vue'

const locale = zhCn
</script>

<style scoped>
</style>
